import { useState } from 'react';
import { useMutation } from 'react-query';
import { useNavigate } from 'react-router-dom';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import { Dialog, PageHeader } from 'Components/ui';
import { useTranslation } from 'react-i18next';
import { adminTriggerBatch } from 'services/scanner-service';

export const AdminScannerBatch = () => {
  const { t } = useTranslation('scanner');
  const navigate = useNavigate();
  const [lastBatch, setLastBatch] = useState(null);

  const triggerMutation = useMutation(() => adminTriggerBatch(), {
    onSuccess: (res) => {
      const { batchId, totalAccounts, triggered, failed } = res.data;
      const batchResult = { batchId, totalAccounts, triggered, failed, triggeredAt: new Date() };
      setLastBatch(batchResult);
      Dialog.fire({
        icon: 'success',
        title: t('adminBatch.successTitle'),
        html: t('adminBatch.successHtml', { batchId, triggered, totalAccounts }),
        confirmButtonText: t('adminBatch.viewResult'),
      }).then((result) => {
        if (result.isConfirmed) navigate(`/admin/scanner/batch/${batchId}`, { state: batchResult });
      });
    },
    onError: () => Dialog.fire({ title: t('common:errors.generic'), text: t('adminBatch.errorMessage'), icon: 'error' }),
  });

  const handleTrigger = async () => {
    const confirmed = await Dialog.confirm({
      title: t('adminBatch.confirmTitle'),
      message: t('adminBatch.confirmText'),
      confirmLabel: t('adminBatch.confirmButton'),
      cancelLabel: t('common:buttons.cancel'),
    });
    if (confirmed) triggerMutation.mutate();
  };

  return (
    <div className="mt-3 px-3">
      <PageHeader
        title={t('adminBatch.title')}
        segments={[
          { label: t('common:breadcrumbs.globalSettings') },
          { label: t('adminBatch.title') },
        ]}
        actions={
          <button className="btn btn-success" onClick={handleTrigger} disabled={triggerMutation.isLoading}>
            <PlayArrowIcon fontSize="small" /> {triggerMutation.isLoading ? t('adminBatch.running') : t('adminBatch.runNow')}
          </button>
        }
      />

      <p className="text-muted">{t('adminBatch.description')}</p>

      {lastBatch && (
        <div className="alert alert-info">
          <strong>{t('adminBatch.lastBatch')}</strong>{' '}
          {lastBatch.triggered}/{lastBatch.totalAccounts} {t('adminBatch.accountsTriggered')} —{' '}
          {lastBatch.triggeredAt.toLocaleString('pt-BR')}
          <button
            className="btn btn-sm btn-outline-primary ms-3"
            onClick={() => navigate(`/admin/scanner/batch/${lastBatch.batchId}`, { state: lastBatch })}
          >
            {t('adminBatch.viewResult')}
          </button>
        </div>
      )}
    </div>
  );
};
